module.exports = __webpack_public_path__ + "img/Linda Coleman-Madison.3d1547b6.jpg";